import React, { CSSProperties } from 'react';
import styles from './style.module.css';

const LoadingAnimation = ({
  loadingColor = '',
  style,
}: {
  loadingColor?: string;
  style?: CSSProperties;
}) => {
  return (
    <div className={styles.spinner} style={style}>
      <div className={styles['lds-roller']}>
        {[...Array(8)].map((_, index) => (
          <div key={index} className={loadingColor} />
        ))}
      </div>
    </div>
  );
};

export default LoadingAnimation;
